"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * EpubViewer wrapper style
 */
var styles = {
  boxSizing: "border-box",
  margin: "0px auto",
  width: "100%",
  height: "100%",
  overflowY: 'hidden'
};
var _default = styles;
exports.default = _default;